import { useState } from "react";
import { Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";
import useAutoFocus from "../../Utils/autoFocus";
import image from '../../assets/Images/college-logo.png'
import { formatDate } from "../../Utils/data&dateTime";
import directorSign from '../../assets/Images/director_signatures.jpeg'
export const ScheduleFeePreview = ({
    isOpen,
    onClose,
    previewData,
    onContinue,
    selectedSessionName, isSubmittingCalc
}) => {


    const [pin, setPin] = useState("");
    const ref = useAutoFocus(isOpen)
    if (!isOpen || !previewData) return null;

    const {
        payload,
        selectedCourse,
        selectedSemester,
        selectedStudents,
        filteredStudents,
        dueDate,
        calcImposePenalty,
        calcPenaltyAmount,
        calcPenaltyMaxAmount,
        student_fee_amounts,
        paymentTypes,
        copyToData,
        copyToDisplayData
    } = previewData;



    const totalAmountScheduled = student_fee_amounts?.reduce((sum, stuFee) => {
        const headsTotal = Object.values(stuFee.heads || {}).reduce(
            (a, b) => a + Number(b || 0),
            0
        );
        return sum + headsTotal;
    }, 0);

    const handleVerifyPinAndContinue = async () => {
        if (pin.length !== 4) return;
        try {
            const res = await Postdata("core/verify-user-pin/", { pin });
            if (!res?.error) {
                if (typeof onContinue === "function") onContinue(payload);
                setPin("");
            } else {
                Notifier.error(res?.data?.message || "Invalid PIN");
            }
        } catch (err) {
            Notifier.error("Something went wrong while verifying PIN");
        }
    };


    // 🔹 Print Feature
    //     const handlePrint = () => {
    //         if (typeof onClose === "function") onClose();
    //   const allowedFeeHeadIds = payload?.fee_head_ids
    //     ?.split(",")
    //     ?.map((id) => id.trim()) || [];

    //         // Build table HTML
    //         let tableHtml = "";
    //         if (payload?.plan_mode === "course") {

    //                 // 🔹 Collect all heads from all students
    //     const allHeads = student_fee_amounts.flatMap((sf) =>
    //       Object.entries(sf.heads || {})
    //     );

    //     // 🔹 Filter and deduplicate by allowed fee head IDs
    //     const uniqueHeads = Array.from(
    //       new Map(
    //         allHeads.filter(([feeHeadId]) =>
    //           allowedFeeHeadIds.includes(String(feeHeadId))
    //         )
    //       ).entries()
    //     );
    //             tableHtml = `
    //             <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:14px;">
    //                 <thead>
    //                     <tr>
    //                         <th>Fee Head</th>
    //                         <th>Amount</th>
    //                     </tr>
    //                 </thead>
    //                <tbody>
    //           ${
    //             uniqueHeads
    //               .map(([feeHeadId, amount]) => {
    //                 const headName =
    //                   paymentTypes.find(
    //                     (p) => String(p.value) === String(feeHeadId)
    //                   )?.label || feeHeadId;
    //                 return `<tr><td>${headName}</td><td>₹${amount}</td></tr>`;
    //               })
    //               .join("") || "<tr><td colspan='2'>No data available</td></tr>"
    //           }
    //         </tbody>
    //             </table>`;
    //         } else {
    //             tableHtml = `
    //             <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:14px;">
    //                 <thead>
    //                     <tr>
    //                         <th>Student Name</th>
    //                         <th>Reg No</th>
    //                         <th>Fee Head</th>
    //                         <th>Amount</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     ${student_fee_amounts.map(stuFee => {
    //                 const stu = filteredStudents.find(s => s.id === stuFee.student_id);
    //                 return Object.entries(stuFee.heads || {}).map(([feeHeadId, amount]) => {
    //                     const headName = paymentTypes.find(p => p.value === Number(feeHeadId))?.label || feeHeadId;
    //                     return `<tr>
    //                                 <td>${stu?.name || "-"}</td>
    //                                 <td>${stu?.rollNumber || "-"}</td>
    //                                 <td>${headName}</td>
    //                                 <td>₹${amount}</td>
    //                             </tr>`;
    //                 }).join("");
    //             }).join("")}
    //                 </tbody>

    //             </table>`;
    //         }
    //         const newWindow = window.open("width=800,height=1100");
    //         newWindow.document.write(`
    //             <html>
    //                 <head>
    //                     <title>Scheduled Fee Plan Preview</title>
    //                     <style>
    //                         body { font-family: "Courier New", Courier, monospace; padding: 40px 0; color: #222F3E; background: #fff; }
    //                         .print-container { width: 700px; margin: 0 auto; }
    //                         h2, p { margin: 4px 0; text-align: center; }
    //                         hr { border: 0; border-top: 1px dashed #222F3E; margin: 10px 0; }
    //                         table { width: 100%; border-collapse: collapse; font-size: 14px; margin-top: 10px; }
    //                         table th, table td { border: 1px solid #222F3E; padding: 6px; }
    //                         table th { text-align: left; }
    //                         .center { text-align: center; }
    //                     </style>
    //                 </head>
    //                 <body>
    //                     <div class="print-container">
    //                         <div class="center">
    //                             <h2>BITE College</h2>
    //                             <p>Banaras Institute of Teachers Education</p>
    //                             <hr />
    //                             <h3>Scheduled Fee Plan Preview</h3>
    //                             <hr />
    //                         </div>
    //                          <p><strong>Academic Year:</strong> ${selectedSessionName}</p>


    //                         <p><strong>Courses:</strong> ${selectedCourse?.map(c => c.label).join(", ") || "-"}</p>
    //                       ${selectedSemester?.length
    //                 ? `<p><strong>Semesters:</strong> ${selectedSemester.map(s => `${s.courseName} - ${s.label}`).join(", ")}</p>`
    //                 : ""
    //             }


    //                         <p><strong>Total Students:</strong> ${selectedStudents.length}</p>
    //                         <p><strong>Total Scheduled Amount:</strong> ₹${totalAmountScheduled?.toFixed(2)}</p>
    //                         <p><strong>Due Date:</strong> ${dueDate}</p>
    //                         ${calcImposePenalty ? `<p><strong>Penalty/Day:</strong> ₹${calcPenaltyAmount}</p>
    //                         <p><strong>Max Penalty:</strong> ₹${calcPenaltyMaxAmount?.toFixed(2)}</p>` : ""}
    //                         <hr />
    //                         ${tableHtml}
    //                         <div style="margin-top:80px; display:flex; justify-content:flex-end; width:100%;">

    //   <div>Director</div>
    // </div>

    //                         <hr />
    //                         <div class="center">
    //                             <p>Generated on: ${new Date().toLocaleString()}</p>
    //                         </div>
    //                     </div>
    //                 </body>
    //             </html>
    //         `);
    //         newWindow.document.close();
    //         newWindow.focus();
    //         newWindow.print();
    //         newWindow.close();
    //     };


    // 🔹 Print Feature (Updated - Announcement Style)


    const handlePrint = async () => {
        if (typeof onClose === "function") onClose();

        const toBase64 = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        };

        const base64Logo = await toBase64(image);
        const base64DirectorSign = await toBase64(directorSign);

        const allowedFeeHeadIds =
            payload?.fee_head_ids?.split(",")?.map((id) => id.trim()) || [];

        const courseSemesterText = selectedSemester?.length
            ? selectedSemester.map((s) => `${s.label}`).join(", ")
            : selectedCourse?.map((c) => c.label).join(", ") || "-";

        // 🔹 Get students for individual plan mode
        const studentIds = payload?.student_ids
            ?.split(",")
            ?.map((id) => Number(id.trim()));
        const matchedStudents = filteredStudents?.filter((s) =>
            studentIds?.includes(s.id)
        );

        // 🔹 Combine course + semester for display in individual mode
        const courseText =
            selectedSemester?.length && selectedCourse?.length
                ? selectedCourse
                    .map((c, index) => {
                        const semester = selectedSemester[index]?.label
                            ? ` - ${selectedSemester[index]?.label}`
                            : "";
                        return `${c.label}${semester}`;
                    })
                    .join(", ")
                : courseSemesterText;

        // 🔹 Conditional notice text
        const noticeText =
            payload?.plan_mode === "individual"
                ? `
      <p style="text-align: justify;">
        The following students of (<strong>${courseText}</strong>) are hereby informed to deposit their pending fees by 
        <strong>${formatDate(new Date(dueDate))}</strong>:
      </p>
       <ol style="margin-top:8px; padding-left:25px; line-height:1.6; list-style-type: decimal !important; list-style-position: outside !important; margin-left: 20px;">
        ${matchedStudents?.length
                    ? matchedStudents
                        .map((s) => `<li style="margin-bottom:4px;">${s.name} (${s.rollNumber})</li>`)
                        .join("")
                    : "<li>-</li>"
                }
      </ol>
    `
                : `
      <p style="text-align: justify;">
       This is to inform all students of
        <strong>${courseSemesterText}</strong> 
        that they must deposit their pending fees by <strong>${formatDate(new Date(dueDate))}</strong>.
      </p>
    `;



        const penaltyText = calcImposePenalty
            ? `
            <div class="penalty-section">
            <h4>Important:</h4>
            <ul>
                <li>Delay in payment will attract a penalty of 
                <strong>₹${calcPenaltyAmount}</strong> per day, 
                subject to a maximum of <strong>₹${calcPenaltyMaxAmount?.toFixed(
                2
            )}</strong>.
                </li>
                <li>Students are advised to pay the fee within the stipulated time to avoid penalties.</li>
            </ul>
            </div>
        `
            : "";

        const newWindow = window.open("width=800,height=1100");

        const copyToHTML =
            copyToDisplayData &&
                copyToDisplayData.length > 0 &&
                copyToDisplayData.some((c) => c.designation?.trim() || c.reason?.trim())
                ? `
  <div class="copyto">
    <strong>Copy to:</strong>
    <ol>
      ${copyToDisplayData
                    .filter((c) => c.designation?.trim() || c.reason?.trim())
                    .map((c) => `<li>${c.designation} (${c.reason})</li>`)
                    .join("")}
    </ol>
  </div>
`
                : "";

        newWindow.document.write(`
      <html>
        <head>
          <title>Fee Notice</title>
          <style>
            body {
              font-family: "Poppins", "Roboto", sans-serif;
              padding: 40px 0;
              color: #000000;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              background: #ffffff;
            }
            .print-container {
              width: 700px;
              margin: 0 auto;
            }
            h2, p { margin: 4px 0; text-align: center; }
            hr {
              border: 0;
              border-top: 1px dashed #222F3E;
              margin: 10px 0;
            }
            .center { text-align: center; }
            .notice-text {
              text-align: justify;
              font-size: 15px;
              line-height: 1.6;
              margin-top: 30px;
            }
            .footer {
              position: relative;
              margin-top: 100px;
              min-height: 120px;
              width: 100%;
              font-weight: bold;
              font-size: 15px;
            }
            .copyto {
              position: absolute;
              left: 0;
              bottom: 0;
              text-align: left;
              font-size: 14px;
              line-height: 1.6;
              margin-left: 20px;
            }
            .signature {
              position: absolute;
              right: 0;
              bottom: 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
            }
            .copyto ol { margin: 4px 0 0 20px; padding: 0; }
            .copyto li { margin-bottom: 2px; }
            .cityname { font-weight: bold; font-size:18px; }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="center">
              <img id="collegeLogo" src="${base64Logo}" alt="College Logo" width="80" height="80" />
              <h2>Banaras Institute of Teacher's Education</h2>
              <p>(Affiliated with Mahatma Gandhi Kashi Vidyapeeth  Varanasi)</p>
              <h5 class="cityname">Babatpur, Varansi</h5>
              <hr />
            </div>

            <div class="notice-text">${noticeText}</div>
            ${penaltyText}

            <div class="footer">
              ${copyToHTML}
              <div class="signature">
                <img src="${base64DirectorSign}" alt="Director Signature" width="120" height="auto" style="margin-bottom: 4px;" />
                <span>Director</span>
              </div>
            </div>

            <hr />
            <div class="center">
              <p>Generated on: ${new Date().toLocaleString()}</p>
            </div>
          </div>
        </body>
      </html>
    `);

        newWindow.document.close();

        newWindow.onload = () => {
            const logoImg = newWindow.document.getElementById("collegeLogo");

            if (logoImg && !logoImg.complete) {
                logoImg.onload = () => {
                    newWindow.focus();
                    newWindow.print();
                    newWindow.close();
                };
            } else {
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }
        };
    };


    return (
        <div className="modal-overlay">
            <div
                className="modal-content recevingPaymentBody"
                id="print-wrapper"
                style={{
                    position: "relative",
                    width: "70%",
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "85vh", // ✅ limit overall height
                    padding: "20px",
                }}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        flexShrink: 0, // prevent shrinking
                    }}
                >
                    <h2 className="text-primary">Scheduled Fee Plan Preview</h2>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <button className="add-btn" onClick={handlePrint}>Print Preview</button>
                        <button className="close-btn" onClick={onClose}>
                            <img src={close} alt="close" />
                        </button>
                    </div>

                </div>


                {/* 🔹 Notice Mode (Unified for Course/Individual before print) */}
                <div
                    className="individualStudentContainer"
                    style={{
                        flex: 1,
                        overflowY: "auto", // ✅ scroll only the body
                        border: "1px solid #eee",
                        borderRadius: "6px",
                        padding: "20px",
                        background: "#fafafa",
                        fontSize: "15px",
                        lineHeight: "1.6",
                    }}
                >
                    <p style={{ textAlign: "justify" }}>
                        {payload?.plan_mode === "individual" ? (
                            <>
                                <p style={{ textAlign: "justify" }}>
                                    The following students of{" "}
                                    <strong>
                                        {selectedSemester?.length
                                            ? selectedSemester.map((s) => s.label).join(" , ")
                                            : selectedCourse?.map((c) => c.label).join(" , ") || "-"}
                                    </strong>{" "}
                                    are hereby informed to deposit their pending fees by{" "}
                                    <strong>{formatDate(new Date(dueDate))}</strong>:
                                </p>

                                {/* 🔹 Scrollable Student List */}
                                <div
                                    className="individualStudentContainer"
                                    style={{
                                        maxHeight: "300px", // adjust as needed
                                        overflowY: "auto",
                                        border: "1px solid #ddd",
                                        borderRadius: "6px",
                                        padding: "10px 15px",
                                        marginTop: "8px",
                                        background: "#fafafa",
                                    }}
                                >
                                    <ol
                                        style={{
                                            margin: 0,
                                            paddingLeft: "25px",
                                            lineHeight: "1.6",
                                            listStyleType: "decimal",
                                            listStylePosition: "outside",
                                        }}
                                    >
                                        {(() => {
                                            const studentIds = payload?.student_ids
                                                ?.split(",")
                                                ?.map((id) => Number(id.trim()));
                                            const matchedStudents = filteredStudents?.filter((s) =>
                                                studentIds?.includes(s.id)
                                            );

                                            return matchedStudents?.length ? (
                                                matchedStudents.map((s) => (
                                                    <li key={s.id}>
                                                        {s.name} ({s?.rollNumber})
                                                    </li>
                                                ))
                                            ) : (
                                                <li>-</li>
                                            );
                                        })()}
                                    </ol>
                                </div>


                            </>
                        ) : (
                            <>
                                This is to inform all students of{" "}
                                <strong>
                                    {selectedSemester?.length
                                        ? selectedSemester
                                            .map((s) => `${s.label}`)
                                            .join(", ")
                                        : selectedCourse?.map((c) => c.label).join(", ") || "-"}
                                </strong>{" "}
                                that they must deposit their pending fees by{" "}
                                <strong>{formatDate(new Date(dueDate))}</strong>.
                            </>
                        )}
                        <br /> <br />
                    </p>

                    {calcImposePenalty && (
                        <div style={{ marginTop: "25px" }}>
                            <h4 style={{ textDecoration: "underline", marginBottom: "8px", color: 'black', fontSize: '16px', fontWeight: '500' }}>
                                Important:
                            </h4>
                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                <li>
                                    Delay in payment will attract a penalty of <strong>₹{calcPenaltyAmount}</strong>  per
                                    day, subject to a maximum of
                                    <strong> ₹{calcPenaltyMaxAmount?.toFixed(2)}.</strong>
                                </li>
                                <li>
                                    Students are advised to pay the fee within the stipulated time to
                                    avoid penalties.
                                </li>
                            </ul>
                        </div>
                    )}
                    {copyToDisplayData &&
                        copyToDisplayData.length > 0 &&
                        copyToDisplayData.some(
                            (item) => item.designation?.trim() || item.reason?.trim()
                        ) && (
                            <div className="mt-3">
                                <p><strong>Copy to:</strong></p>
                                {copyToDisplayData.map((item, idx) => (
                                    (item.designation?.trim() || item.reason?.trim()) && (
                                        <p key={idx} className="d-flex justify-content-between">
                                            <span>
                                                {item.designation} ({item.reason})
                                            </span>
                                        </p>
                                    )
                                ))}
                            </div>
                        )}




                </div>


                {/* Course/Semester + Due/Penalty Info */}

                {/* <div
                    style={{
                        marginBottom: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: "20px",
                    }}
                >
                    
                    <div style={{ flex: 1, minWidth: "250px" }}>

                        {selectedSessionName && (
                            <p>
                                <strong>Admission Academic Year:</strong> {selectedSessionName}
                            </p>
                        )}
                        <p>
                            <strong>Courses:</strong>{" "}
                            {selectedCourse?.map(c => c.label).join(", ") || "-"}
                        </p>

                        {selectedSemester?.length > 0 && (
                            <p>
                                <strong>Semesters:</strong>{" "}
                                {selectedSemester.map(s => `${s.courseName} - ${s.label}`).join(", ")}
                            </p>
                        )}

                        <p><strong>Total Students:</strong> {selectedStudents.length}</p>
                    </div>

                    
                    <div style={{ flex: 1, minWidth: "250px" }}>
                        <p>
                            <strong>Total Scheduled Amount:</strong> ₹
                            {totalAmountScheduled?.toFixed(2)}
                        </p>
                        <p>
                            <strong>Due Date:</strong> {dueDate}
                        </p>
                        {calcImposePenalty && (
                            <>
                                <p>
                                    <strong>Penalty/Day:</strong> ₹
                                    {calcPenaltyAmount}
                                </p>
                                <p>
                                    <strong>Max Penalty:</strong> ₹
                                    {calcPenaltyMaxAmount}
                                </p>
                            </>
                        )}
                    </div>
                </div> */}

                {/* 🔹 Course Mode */}

                {/* {payload?.plan_mode === "course" && (
                    <div
                        style={{
                            flex: 1,
                            border: "1px solid #eee",
                            borderRadius: "6px",
                            padding: "10px",
                        }}
                    >
                        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                            <table className="table table-bordered mt-2">
                                <thead style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#fff",
                                    zIndex: 2,
                                }}>
                                    <tr>
                                        <th>Fee Head</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(() => {
                                        if (!student_fee_amounts?.length) return null;

                                        // 🔹 Extract all head entries from all students
                                        const allHeads = student_fee_amounts.flatMap((sf) =>
                                            Object.entries(sf.heads || {})
                                        );

                                        // 🔹 Get unique & allowed fee head IDs from payload
                                        const allowedFeeHeadIds = payload?.fee_head_ids
                                            ?.split(",")
                                            ?.map((id) => id.trim());

                                        // 🔹 Filter + remove duplicates
                                        const uniqueHeads = Array.from(
                                            new Map(
                                                allHeads.filter(([feeHeadId]) =>
                                                    allowedFeeHeadIds?.includes(String(feeHeadId))
                                                )
                                            ).entries()
                                        );

                                        // 🔹 Render each allowed fee head once
                                        return uniqueHeads.map(([feeHeadId, amount]) => {
                                            const headName =
                                                paymentTypes.find(
                                                    (p) => String(p.value) === String(feeHeadId)
                                                )?.label || feeHeadId;

                                            return (
                                                <tr key={feeHeadId}>
                                                    <td>{headName}</td>
                                                    <td>₹{amount}</td>
                                                </tr>
                                            );
                                        });
                                    })()}
                                </tbody>

                            </table>
                        </div>
                    </div>
                )} */}

                {/* 🔹 Individual Mode */}

                {/* {payload?.plan_mode === "individual" && (
                    <div
                        style={{
                            flex: 1,
                            border: "1px solid #eee",
                            borderRadius: "6px",
                            padding: "10px",
                        }}
                    >
                        <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                            <table className="table table-bordered mt-2">
                                <thead style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#fff",
                                    zIndex: 2,
                                }}>
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Reg No</th>
                                        <th>Fee Head</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {student_fee_amounts?.map((stuFee) => {
                                        const stu = filteredStudents.find(
                                            (s) => s.id === stuFee.student_id
                                        );
                                        return Object.entries(
                                            stuFee.heads || {}
                                        ).map(([feeHeadId, amount]) => {
                                            const headName =
                                                paymentTypes.find(
                                                    (p) =>
                                                        p.value ===
                                                        Number(feeHeadId)
                                                )?.label || feeHeadId;
                                            return (
                                                <tr
                                                    key={`${stuFee.student_id}-${feeHeadId}`}
                                                >
                                                    <td>{stu?.name}</td>
                                                    <td>{stu?.rollNumber}</td>
                                                    <td>{headName}</td>
                                                    <td>₹{amount}</td>
                                                </tr>
                                            );
                                        });
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )} */}

                {/* Footer with PIN */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "20px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                        }}
                    >
                        <input
                            type="password"
                            className="form-control"
                            maxLength={4}
                            placeholder="Enter 4-digit PIN"
                            value={pin}
                            ref={ref}
                            onChange={(e) =>
                                setPin(e.target.value.replace(/\D/g, ""))
                            }
                            style={{
                                width: "150px",
                                padding: "8px 10px",
                                textAlign: "center",
                                fontSize: "13px",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                outline: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        <button
                            className="add-btn"
                            onClick={handleVerifyPinAndContinue}
                            disabled={pin.length !== 4}
                            style={{
                                cursor:
                                    pin.length !== 4
                                        ? "not-allowed"
                                        : "pointer",
                                backgroundColor:
                                    pin.length !== 4 ? "#d3d3d3" : "#7F56DA",
                            }}
                        >
                            {isSubmittingCalc ? (
                                <span className="spinner-border spinner-border-sm" role="status" />
                            ) : (
                                "Continue"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
